import React from "react";

function Home() {
  return (
    <div className="p-8 text-center bg-gray-100 w-full h-full min-h-screen flex items-center justify-center flex-col">
      <h1 className="text-2xl font-bold">Welcome to Project Hub</h1>
      <p>Please select a project and then navigate to the appropriate section.</p>
    </div>
  );
}

export default Home;
